<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Lista de Programas de aportaciones</h3>
				<div class="card-tools">
					<button @click="wallet()" v-can="'add_programs'" class="btn btn-sm btn-outline-success mr-1">
						<i class="fa-solid fa-circle-dollar-to-slot"></i> Monederos
					</button>
					<button @click="form()" v-can="'add_programs'" class="btn btn-sm btn-outline-info">
						<i class="fa fa-plus"></i> Programa
					</button>
				</div>
			</div>

			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<label>Buscar :</label>
						<input type="text" class="form-control" v-model="search.name" @keyup="list()" />
					</div>
				</div>
				<br>
				<div class="table-responsive">
					<table class="table table-bordered text-center text-sm">
						<thead>
							<tr>
								<th>ID</th>
								<th>Nombre</th>
								<th>Tipo de Programa</th>
								<th>Total / Aportaciones</th>
								<!-- <th>Cantidad de aportaciones</th> -->
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="10">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>

								</td>
							</tr>
						</tbody>
						<tbody v-else-if="programs.total > 0">
							<tr v-for="(program, index) in programs.data" :key="index">
								<td>{{ program.id }}</td>
								<td>{{ program.name }}</td>
								<td>{{ program.program_type.name }}
								</td>
								<td>									
									<span v-if="program.program_type_id == 1">
										{{ program.total | money }}
										<br>-<br>
									</span>
									{{ program.contributions_sum_amount | money }}
								</td>
								<!-- <td>{{ program.contributions_count }}</td> -->
								<td>
									<button @click="edit(program.id)" v-can="'edit_programs'"
										class="btn m-1 btn-outline-primary btn-sm">
										<i class="fas fa-edit"></i> Editar
									</button>

									<button @click="openGroupUsersList(program.id)" v-can="'edit_programs'"
										class="btn m-1 btn-outline-secondary btn-sm">
										<i class="fa-solid fa-users"></i> Reporte General
									</button>

									<button type="button" @click="deleted(program.id)" v-can="'delete_programs'"
										class="btn-outline-danger btn m-1 btn-sm">
										<i class="fa fa-trash"></i> Eliminar
									</button>

									<router-link :to="`/programs_investors/${program.id}`" v-can="'programs_investors'"
										class="btn-outline-info btn m-1 btn-sm">
										<i class="fa-solid fa-money-bill-trend-up"></i> Detalle de aportaciones
									</router-link>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="5">Sin resultados.</td>
							</tr>
						</tbody>
					</table>
					<pagination v-if="programs && programs.total" v-model="page" :records="programs.total"
						:per-page="programs.per_page" @paginate="list" />
				</div>
			</div>
		</div>
		<ModalFormComponent />
		<ModalFormEditComponent />
		<ModalProgramGroupUsersList />
		<ModalFormWalletComponent />
	</div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import Pagination from 'vue-pagination-2';
import request from '@/services/request';
import ModalFormComponent from '@/components/programs/ModalFormComponent.vue';
import ModalFormEditComponent from '@/components/programs/ModalFormEditComponent.vue';
import ModalProgramGroupUsersList from '@/components/programs/groups_user/ModalProgramGroupUserList.vue';
import ModalFormWalletComponent from '@/components/wallet/ModalFormWalletComponent.vue';

export default {
	name: 'programs-table',
	components: {
		Pagination,
		ModalFormComponent,
		ModalFormEditComponent,
		ModalProgramGroupUsersList,
		ModalFormWalletComponent
	},
	props: {
		prop_edit: {
			default: true,
		}
	},
	data() {
		return {
			programs: {},
			search: {
				name: '',
			},
			load: false,
			page: 1,
		};
	},
	mounted() {
		this.list();
		this.setHeaderTitle('Programas de aportaciones');
	},
	methods: {
		wallet() {
			Event.$emit('event-show-walletRecharge');
		},
		form() {
			Event.$emit('event-from-program');
		},
		edit(id) {
			Event.$emit('event-edit-program', id);
		},
		openGroupUsersList(id) {
			Event.$emit("event-open-program-groups-users-list", {
				program_id: id
			});
		},
		deleted(id) {
			let tit = 'Eliminar programa';
			let txt = 'Seguro que quiere eliminar el programa';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		async callDeleted(id) {
			let _endpoint = '/programs/' + id;
			try {
				let response = await request
					.destroy(_endpoint)
					.then(function (response) {
						return response;
					});
				this.list();
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error);
			}
		},
		async list(page = 1) {
			this.load = true;
			let service = request;
			let search = this.search;
			let _endpoint = '/programs';
			try {
				let { data } = await service.list(_endpoint, page, search);
				if (data) {
					this.programs = data;
					this.load = false;
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	watch: {
		search: {
			handler() {
				this.list();
			},
			deep: true,
		},
	},
	created() {
		Event.$on("event-load-program", () => {
			this.list();
		});
	}
};
</script>

<style scoped>
.pagination {
	margin-bottom: 0;
}
</style>
